<template>
  <b-sidebar
    id="edit-branch-sidebar"
    :visible="isEditItemSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="fetchSidebarData"
    @hidden="hideSidebar"
    @change="val => $emit('update:is-edit-item-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
Edit Item
</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <validation-observer
        ref="refFormObserver"
        #default="{ invalid }"
      >
        <b-form
          class="p-2"
          @submit.prevent="editItem"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name"
              label-for="Name"
            >
              <b-form-input
                id="Name"
                v-model="itemData.ItemName"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="Item Name"
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Item Code"
          >
            <b-form-group
              label="Code"
              label-for="KodeItem"
            >
              <b-form-input
                id="KodeItem"
                v-model="itemData.ItemCode"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Item Code"
                readonly
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Unit"
          >
            <b-form-group
              label="Unit"
              label-for="itemUnit"
            >
              <v-select-new
                v-model="itemData.ChosenUnit"
                :filterable="true"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="getValidationState(validationContext)"
                :options="units"
                placeholder="Item Unit"
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Category"
            rules="required"
          >
            <b-form-group
              label="Category"
              label-for="Category"
            >
              <v-select-new
                v-model="itemData.ItemCategory"
                :filterable="true"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="getValidationState(validationContext)"
                :options="itemCategories"
                placeholder="Item Category"
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="AgeCategory"
          >
            <b-form-group
              label="Age Category"
              label-for="ItemAgeCategory"
            >
              <v-select-new
                v-model="itemData.ItemAgeCategory"
                :filterable="true"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="getValidationState(validationContext)"
                :options="itemagescategories"
                placeholder="Item Age Category"
                disabled
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="ItemEstAge"
          >
            <b-form-group
              label="Item Est Age"
              label-for="ItemEstAge"
            >
              <b-form-input
                id="ItemEstAge"
                v-model="itemData.ItemEstAge"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Item Est Age"
                readonly
                @keypress="isNumber($event)"
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="ItemEstDelivery"
          >
            <b-form-group
              label="Item Est Delivery (Days)"
              label-for="ItemEstDelivery"
            >
              <b-form-input
                id="ItemEstDelivery"
                v-model="itemData.ItemEstDelivery"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Item Est Delivery"
                readonly
                @keypress="isNumber($event)"
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="ItemAllotment"
          >
            <b-form-group
              label="Allotment"
              label-for="ItemAllotment"
            >
              <v-select-new
                v-model="itemData.ItemAllotment"
                :filterable="true"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="getValidationState(validationContext)"
                :options="allotments"
                placeholder="Item Allotment"
                disabled
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              block
              :disabled="invalid"
            >
              Save
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hideSidebar"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormFile,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import { ref } from '@vue/composition-api'
import moment from 'moment-timezone'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isEditItemSidebarActive',
    event: 'update:is-edit-item-sidebar-active',
  },
  props: {
    isEditItemSidebarActive: { type: Boolean, required: true },
    itemId: { type: Number, required: true },
    itemName: { type: String, required: true },
    itemCode: { type: String, required: true },
    itemCategory: { type: [String, Object], required: true },
    itemAgeCategory: { type: [String, Object], required: true },
    itemEstAge: { type: [String, Number], required: true },
    itemEstDelivery: { type: [String, Number], required: true },
    itemAllotment: { type: [String, Object], required: true },
    chosenUnit: { type: [String, Object], required: true },
  },
  setup() {
    const blankItemData = {
      ItemName: '',
      ItemCode: '',
      ItemCategory: null,
      ItemAgeCategory: null,
      ItemEstAge: '',
      ItemEstDelivery: '',
      ItemAllotment: null,
      ChosenUnit: null,
    }

    const itemData = ref(JSON.parse(JSON.stringify(blankItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankItemData))
    }

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetItemData)

    return {
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  data() {
    return {
      itemagescategories: [
        { label: 'Slow', value: 'slow' },
        { label: 'Medium', value: 'medium' },
        { label: 'Fast', value: 'fast' },
      ],
      allotments: [
        { label: 'Production', value: 'production' },
        { label: 'Non Production', value: 'nonproduction' },
      ],
      itemCategories: [
        { label: 'Chemicals', value: 'Chemicals' },
        { label: 'Tools & Spare Parts', value: 'Tools & Spare Parts' },
        { label: 'Plasticware', value: 'Plasticware' },
        { label: 'Glassware', value: 'Glassware' },
        { label: 'Stationery & ATK', value: 'Stationery & ATK' },
        { label: 'Office Supplies', value: 'Office Supplies' },
        { label: 'General Supplies', value: 'General Supplies' },
        { label: 'Gases', value: 'Gases' },
        { label: 'Drilling Supplies', value: 'Drilling Supplies' },
        { label: 'Equipment', value: 'Equipment' },
        { label: 'Finished Good Services', value: 'Finished Good Services' },
        { label: 'Safety', value: 'Safety' },
        { label: 'Assets', value: 'Assets' },
        { label: 'Fixed Assets', value: 'Fixed Assets' },
        { label: 'Software', value: 'Software' },
      ],
      units: [],
      currencies: [],
      file: null,
      required,
      alphaNum,
    }
  },
  methods: {
    hideSidebar() {
      this.$emit('update:is-edit-item-sidebar-active', false)
      this.resetForm()
    },
    fetchSidebarData() {
      this.getUnits()
      this.itemData.ItemName = this.itemName
      this.itemData.ItemCode = this.itemCode
      this.itemData.ItemCategory = this.itemCategory
      this.itemData.ItemAgeCategory = this.itemAgeCategory
      this.itemData.ItemEstAge = this.itemEstAge
      this.itemData.ItemEstDelivery = this.itemEstDelivery
      this.itemData.ItemAllotment = this.itemAllotment
      this.itemData.ChosenUnit = this.chosenUnit
    },
    isNumber(evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
        return false
      }
      return true
    },
    getUnits() {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }
      axios
        .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_UNIT}`, { headers })
        .then(response => {
          if (response.data && response.data.data) {
            this.units = response.data.data.map(elem => ({
              label: elem.unit_name,
              value: elem.unit_id,
            }))
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    editItem() {
      this.$refs.refFormObserver.validate().then(success => {
        if (!success) return

        const userToken = this.$cookies.get('userToken')
        const formData = new FormData()

        if (this.file && this.file[0]) {
          formData.append('file', this.file[0], this.file[0].name)
        }

        const getValue = field => (field && field.value ? field.value : field)

        formData.append('item_id', this.itemId)
        formData.append('item_name', this.itemData.ItemName)
        formData.append('item_code', this.itemData.ItemCode)
        formData.append('item_category', getValue(this.itemData.ItemCategory))
        formData.append('item_age_category', getValue(this.itemData.ItemAgeCategory))
        formData.append('item_est_age', this.itemData.ItemEstAge)
        formData.append('item_est_delivery', this.itemData.ItemEstDelivery)
        formData.append('item_allotment', getValue(this.itemData.ItemAllotment))
        formData.append('item_unit_id', getValue(this.itemData.ChosenUnit))
        formData.append('time', moment().format())

        const header = {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${userToken}`,
        }

        const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_EDIT_ITEMS}`

        axios
          .post(url, formData, { headers: header, crossDomain: true })
          .then(response => {
            if (response.data.success === true) {
              this.hideSidebar()
              this.$root.$emit('refreshTable', 'refreshTable')
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: 'Your data has been updated!',
                },
              })
            } else {
              this.showErrorToast()
            }
          })
          .catch(error => {
            console.error(error)
            this.showErrorToast()
          })
      })
    },
    handleFilesUpload(e) {
      this.file = e.target.files || e.dataTransfer.files
    },
    showErrorToast() {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Notification',
          icon: 'BellIcon',
          variant: 'danger',
          text: 'Something went wrong',
        },
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#edit-branch-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>